import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

/**
 * Esqueleto com a MESMA altura de linha da tabela. Se o esqueleto tivesse
 * altura diferente, a tela saltaria ao carregar — e em fila densa isso faz
 * a pessoa perder a linha que estava lendo.
 */
export function EstadoDeCarregamento({ linhas = 8 }: { linhas?: number }): React.JSX.Element {
  return (
    <Box role="status" aria-live="polite" aria-busy="true" sx={{ p: 1 }}>
      <Box sx={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>
        Carregando…
      </Box>
      {Array.from({ length: linhas }, (_, indice) => (
        <Skeleton
          key={indice}
          variant="rectangular"
          sx={(tema) => ({ height: tema.anery.alturaDeLinha - 6, mb: '6px', borderRadius: 1 })}
        />
      ))}
    </Box>
  );
}
